<div class="legal-page">
  <div class="legal-page__container">
    <h1>Terms and Conditions</h1>
    <p>Last updated: [date]</p>

    <h2>1. Acceptance of Terms</h2>
    <p>
      By accessing or using the NPS-ANALYST platform you agree to be bound by these Terms and
      Conditions and all applicable laws and regulations. If you do not agree with any part of these
      terms, you must not use the platform.
    </p>

    <h2>2. Use of the Platform</h2>
    <p>
      You agree to use the platform only for lawful purposes and in a way that does not infringe the
      rights of, restrict, or inhibit anyone else's use and enjoyment of the platform.
    </p>

    <h2>3. Accounts and Data</h2>
    <p>
      You are responsible for maintaining the confidentiality of your account credentials and for all
      activities that occur under your account. You agree to provide accurate and complete information
      and to keep your account details up to date.
    </p>

    <h2>4. Intellectual Property</h2>
    <p>
      All content, design, and materials on the platform are owned by or licensed to the platform
      operator and are protected by applicable intellectual property laws.
    </p>

    <h2>5. Limitation of Liability</h2>
    <p>
      The platform is provided on an "as is" and "as available" basis. To the fullest extent permitted
      by law, the platform operator shall not be liable for any indirect, incidental, or consequential
      damages arising from your use of the platform.
    </p>

    <h2>6. Changes to These Terms</h2>
    <p>
      We may revise these Terms and Conditions at any time. Continued use of the platform after changes
      are posted constitutes your acceptance of the revised terms.
    </p>
  </div>
</div>
